import React, { useState, useEffect } from "react";
import useMakeScrollable from "custom_hooks/make-scrollable";
import closeIcon from "../../assets/images/close_icon.png";

const BannerModal = ({ showBanner, setShowBanner, text }) => {
  useMakeScrollable();

  if (!showBanner) return null 
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div 
          className="modal-closeButton"
          onClick={() => setShowBanner(false)}
        >
          <img src={closeIcon} alt="Close" />
        </div>
        <div 
          className="modal-text"
        >
          {text}
        </div>
      </div>
    </div>
  );
};

export default BannerModal;
